;(function () {
  'use strict'
  angular
    .module('contrast.application.assess')
    .controller('AppAssessCtrl', AppAssessCtrl)

  function AppAssessCtrl(
    $scope,
    $uibModal,
    $routeParams,
    $timeout,
    RulesService,
    PromiseService,
    ErrorService,
    SERVER_ENVIRONMENT
  ) {
    'ngInject'

    var _searchKeywords = ''

    // API
    angular.extend($scope, {
      searchKeywords: searchKeywords,
      order: order,
      changeStatus: changeStatus,
      openChangeModeModal: openChangeModeModal,
      onSelectAll: onSelectAll,
      selectAll: selectAll,
      deselectAll: deselectAll,
      toggleSelection: toggleSelection
    })

    function _setDefaults() {
      angular.extend($scope, {
        appId: $routeParams.appId,
        selectedRules: [],
        displayedRules: [],
        model: {
          rules: [],
          isInitialCount: true,
          initialCount: 0,
          count: 0,
          busy: true,
          selectAllCheckbox: false,
          updating: false,
          filteredRules: [],
          row: 'title'
        }
      })
    }

    function init() {
      _setDefaults()
      $scope.model.busy = true
      _loadRules()
    }

    function _loadRules() {
      $scope.displayedRules = []
      $scope.selectedRules = []
      $scope.model.selectAllCheckbox = false

      if ($scope.model.rulesPromise) {
        PromiseService.cancelPromise($scope.model.rulesPromise)
      }

      var params = {
        filterText: $scope.searchKeywords(),
        sort: $scope.model.row
      }

      $scope.model.rulesPromise = RulesService.getByApplication(
        $scope.appId,
        params
      )
        .then(function (data) {
          $scope.model.rules = $scope.model.rules.concat(data.configs)
          $scope.displayedRules = $scope.model.rules.concat(data.configs)
          $scope.model.busy = false
          $scope.model.count = data.configs.length

          if ($scope.model.isInitialCount) {
            $scope.model.initialCount = data.configs.length
            $scope.model.isInitialCount = false
          }

          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })
        })
        .catch(ErrorService.processError)
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      $scope.model.busy = true
      $scope.model.rules = []
      _loadRules()

      return _searchKeywords
    }

    function order(rowName) {
      if ($scope.model.row === rowName) {
        return
      }

      $scope.model.busy = true
      $scope.selectedRules = []
      $scope.model.selectAllCheckbox = false
      $scope.model.rules = []
      $scope.model.row = rowName
      _loadRules()
    }

    function changeStatus(rule, enabled, environment) {
      $scope.model.updating = true
      RulesService.updateStatusByApplication(
        $scope.appId,
        rule,
        enabled,
        environment
      )
        .then(
          _updateRuleEnabled.bind({
            rule: rule,
            enabled: enabled,
            environment: environment
          })
        )
        .catch(ErrorService.processError)
        .finally(function () {
          $scope.model.updating = false
        })
    }

    // Update the matching rule inside $scope.model.rules
    function _updateRuleEnabled() {
      var rules = $scope.model.rules,
        i = 0,
        len = rules.length,
        rule
      for (; i < len; i++) {
        rule = rules[i]
        if (rule.rule_name == this.rule.rule_name) {
          if (this.environment === SERVER_ENVIRONMENT.DEVELOPMENT.value) {
            rule.dev_enabled = this.enabled
          } else if (this.environment === SERVER_ENVIRONMENT.QA.value) {
            rule.qa_enabled = this.enabled
          } else if (this.environment === SERVER_ENVIRONMENT.PRODUCTION.value) {
            rule.prod_enabled = this.enabled
          }
          return
        }
      }
    }

    function openChangeModeModal() {
      $uibModal
        .open({
          templateUrl: 'views/applications/settings/assess_modal.html',
          controller: 'AssessPolicyModalCtrl',
          size: 'md-sm',
          resolve: {
            appId: function () {
              return $scope.appId
            },
            rules: function () {
              return $scope.selectedRules
            }
          }
        })
        .result.then(function () {
          _setDefaults()
          _loadRules()
        })
    }

    function onSelectAll() {
      if ($scope.model.selectAllCheckbox) {
        selectAll()
      } else {
        deselectAll()
      }
    }

    function selectAll() {
      $scope.selectedRules = []
      angular.forEach($scope.displayedRules, function (rule) {
        rule.selected = true
        $scope.selectedRules.push(rule)
      })
    }

    function deselectAll() {
      $scope.selectedRules = []
      angular.forEach($scope.displayedRules, function (rule) {
        rule.selected = false
      })
    }

    function toggleSelection(rule) {
      var idx = $scope.selectedRules.indexOf(rule)

      if (idx > -1) {
        $scope.selectedRules.splice(idx, 1)
      } else {
        $scope.selectedRules.push(rule)
      }

      $scope.model.selectAllCheckbox =
        $scope.selectedRules.length === $scope.displayedRules.length

      return $scope.selectedRules
    }

    init()
  }
})()
